<template>
    <div class="footer">
        <div class="footerNav">
            <div class="footerbar" v-for="footer in footerBar" :key="footer.key">
                <p class="title">{{ footer.title }} </p>
                <div class="navContent">
                    <p class="navLink" v-for="nav in footer.child" :key="nav.key">
                        <a :href="nav.link" target="_blank" v-if="footer.title == 'SOCIAL MEDIA' ">
                            {{ nav.title }}
                        </a>
                        <a :href="nav.link" v-else>
                            {{ nav.title }}
                        </a>
                    </p>
                </div>
            </div>
        </div>
        <div class="copyright">
            © Online Learning Hub 2021
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Footer',
        data() {
            return {
                footerBar :[
                    {
                        title: "COMPANY",
                        child: [
                            {
                                title: "Courses",
                                link: "featuredCourse"
                            },
                            {
                                title: "About Us",
                                link: "aboutUs"
                            },
                            {
                                title: "FAQ",
                                link: ""
                            },
                            {
                                title: "Terms of Service",
                                link: ""
                            },
                            {
                                title: "Privacy Policy",
                                link: ""
                            }
                        ]
                    },
                    {
                        title: "COURSES",
                        child: [
                            {
                                title: "Business Chinese course",
                                link: "featuredCourse"
                            },
                            {
                                title: "Medical Chinese course",
                                link: "featuredCourse"
                            },
                            {
                                title: "HSK 1-6",
                                link: "featuredCourse"
                            },
                            {
                                title: "Coming soon",
                                link: ""
                            }
                        ]
                    },
                    {
                        title: "SOCIAL MEDIA",
                        child: [
                            {
                                title: "Facebook",
                                link: "https://www.facebook.com/ATA-Learning-Hub-101646708649314/"
                            },
                            {
                                title: "Instagram",
                                link: "https://instagram.com/ata_learninghub?r=nametag"
                            },
                            {
                                title: "Youtube",
                                link: "https://youtube.com/channel/UC8_1fioI_WFNlSuwAcjOmBA"
                            },
                            {
                                title: "Twitter",
                                link: "https://twitter.com/ata_learning"
                            },
                            {
                                title: "WhatsApp",
                                link: "https://wa.me/message/SJQNPQZAA25QL1"
                            },
                            {
                                title: "TikTok",
                                link: "https://vt.tiktok.com/ZSJRmB6sC/"
                            },
                            {
                                title: "LinkedIn",
                                link: "http://linkedin.com/in/ata-learning-hub-3327b5207"
                            }
                        ]
                    }
                ]
            }
        },
        mounted() {

        },
        methods: {

        }
    }
</script>

<style lang="scss">
    @import "../styles/pc/footer.scss";
    @import "../styles/mobile/footer.scss";
</style>
